// src/components/HistorialBoletinesPanel.jsx
import React, { useEffect, useState } from 'react';
import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import { FaCheckCircle, FaTimesCircle, FaEnvelopeOpenText } from 'react-icons/fa';
import './EnviarCorreoModal.css';

const HistorialBoletinesPanel = ({ isOpen, onClose, onResend }) => {
  const { fraccionamientoId } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    if (!isOpen) {
      setCurrentPage(1);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        if (!fraccionamientoId) return;
        setLoading(true);
        const col = collection(db, 'fraccionamientos', fraccionamientoId, 'boletines');
        const snap = await getDocs(query(col, orderBy('createdAt', 'desc'), limit(50)));
        if (cancelled) return;
        setItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error('HistorialBoletinesPanel: error al cargar', e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [isOpen, fraccionamientoId]);

  const totalPages = Math.ceil(items.length / itemsPerPage);
  const paginatedItems = items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  if (!isOpen) return null;

  return (
    <div className="mail-modal-overlay history-overlay" role="dialog" aria-modal="true">
      <div className="mail-modal history-modal">
        <div className="mail-modal-header">
          <h3><FaEnvelopeOpenText style={{ marginRight: '12px', verticalAlign: 'middle', color: '#6366f1' }} /> Historial de envíos</h3>
          <button className="mail-close" onClick={onClose} aria-label="Cerrar">×</button>
        </div>

        <div className="mail-modal-body history-body">
          {loading ? (
            <div className="mail-hint">Cargando historial…</div>
          ) : items.length === 0 ? (
            <div className="mail-hint">Sin registros de envíos previos.</div>
          ) : (
            <div className="mail-history-list">
              {paginatedItems.map(h => {
                const date = h.createdAt && h.createdAt.toDate ? h.createdAt.toDate() : (h.createdAt ? new Date(h.createdAt) : null);
                const isSent = h.status === 'sent';
                return (
                  <div key={h.id} className="mail-history-item-card">
                    <div className="history-card-main">
                      <div className="history-card-status">
                        {isSent ? <FaCheckCircle className="status-icon success" /> : <FaTimesCircle className="status-icon error" />}
                      </div>
                      <div className="history-card-info">
                        <div className="history-subject-row">
                          <span className="history-subject">{h.subject}</span>
                          <span className={`history-badge ${isSent ? 'sent' : 'failed'}`}>
                            {isSent ? 'Enviado' : 'Fallido'}
                          </span>
                        </div>
                        <div className="history-meta-row">
                          <span className="history-date">{date ? date.toLocaleString() : '—'}</span>
                          <span className="history-dot">•</span>
                          <span className="history-recipients">{h.toCount || 0} destinatarios</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {totalPages > 1 && (
          <div className="mail-modal-footer history-footer">
            <div className="history-pagination">
              <button
                type="button"
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              >
                Anterior
              </button>
              <span className="pagination-info">
                Página <strong>{currentPage}</strong> de {totalPages}
              </span>
              <button
                type="button"
                className="pagination-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              >
                Siguiente
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistorialBoletinesPanel;
